import { noop } from 'lodash-es';
import { ResourceRowData } from '@features/components/CaseOverview/components/AssignedResources/types';
import { ResourceTable } from '@features/components/CaseOverview/components/AssignedResources/ResourceTable';
import { getEmployeeColumns } from '@features/components/CaseOverview/components/AssignedResources/config';
import { EmployeeRole } from '@/api/apis/resources';

type LogisticCaseManagementContactsProps = {
  onUserAssign: (user: ResourceRowData) => void;
  role: EmployeeRole;
  items: ResourceRowData[];
  isLoading?: boolean;
  loadNextPage?: () => void;
  hasNextPage?: boolean;
};

export const TmdxUsersTable = ({
  onUserAssign,
  role,
  items,
  isLoading = false,
  loadNextPage = noop,
  hasNextPage = false,
}: LogisticCaseManagementContactsProps) => {
  const columns = getEmployeeColumns(role);

  return (
    <ResourceTable
      columns={columns}
      onUserAssign={onUserAssign}
      list={items}
      hasNextPage={hasNextPage}
      isFirstLoading={isLoading}
      loadNextPage={loadNextPage}
    />
  );
};
